/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCoupangInfoVo
 */
export interface UpdateCoupangInfoVo {
    /**
     * coupang取货日
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    coupangInboundDate?: string;
    /**
     * coupang入库ID
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    coupangInboundCode?: string;
    /**
     * coupang公司名称
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    coupangCompanyName?: string;
    /**
     * coupang仓库ID
     * @type {number}
     * @memberof UpdateCoupangInfoVo
     */
    coupangWarehouseId?: number;
    /**
     * coupang本地运输方式ID
     * @type {number}
     * @memberof UpdateCoupangInfoVo
     */
    krLocalTransportMethodId?: number;
    /**
     * 收货人姓名
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    receiverName?: string;
    /**
     * 收货人手机号
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    mobileNO?: string;
    /**
     * 收货人邮政编码
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    zip?: string;
    /**
     * 收货地址
     * @type {string}
     * @memberof UpdateCoupangInfoVo
     */
    receiveAddress?: string;
}

/**
 * Check if a given object implements the UpdateCoupangInfoVo interface.
 */
export function instanceOfUpdateCoupangInfoVo(value: object): value is UpdateCoupangInfoVo {
    return true;
}

export function UpdateCoupangInfoVoFromJSON(json: any): UpdateCoupangInfoVo {
    return UpdateCoupangInfoVoFromJSONTyped(json, false);
}

export function UpdateCoupangInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCoupangInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'coupangInboundDate': json['coupangInboundDate'] == null ? undefined : json['coupangInboundDate'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'coupangCompanyName': json['coupangCompanyName'] == null ? undefined : json['coupangCompanyName'],
        'coupangWarehouseId': json['coupangWarehouseId'] == null ? undefined : json['coupangWarehouseId'],
        'krLocalTransportMethodId': json['krLocalTransportMethodId'] == null ? undefined : json['krLocalTransportMethodId'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNO': json['mobileNO'] == null ? undefined : json['mobileNO'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : json['receiveAddress'],
    };
}

export function UpdateCoupangInfoVoToJSON(json: any): UpdateCoupangInfoVo {
    return UpdateCoupangInfoVoToJSONTyped(json, false);
}

export function UpdateCoupangInfoVoToJSONTyped(value?: UpdateCoupangInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coupangInboundDate': value['coupangInboundDate'],
        'coupangInboundCode': value['coupangInboundCode'],
        'coupangCompanyName': value['coupangCompanyName'],
        'coupangWarehouseId': value['coupangWarehouseId'],
        'krLocalTransportMethodId': value['krLocalTransportMethodId'],
        'receiverName': value['receiverName'],
        'mobileNO': value['mobileNO'],
        'zip': value['zip'],
        'receiveAddress': value['receiveAddress'],
    };
}

